import React from 'react';
import { StockItem } from '../slices/stocksSlice';
import './ItemCard.css';
import { useLang, translations } from '../i18n';

interface Props {
  item: StockItem;
  onDescriptif: () => void;
}

const ItemCard: React.FC<Props> = ({ item, onDescriptif }) => {
  const { lang } = useLang();
  const t = translations[lang];
  const { label, label_en,  pid_number, gmcce, gmcce_en, pdv_final, pdv_filiale, tag } = item.article_sheet_obj;
  const photo = item.article_sheet_obj.photos[0] || process.env.PUBLIC_URL + '/photo-absente.png';
  let used_label = undefined;
  let used_gmcce = undefined;
  if (lang === 'en'){
    used_label = label_en;
    used_gmcce = gmcce_en;
  } else if (lang === 'fr') {
    used_label = label;
    used_gmcce = gmcce
  }
  
  return (
    <div className="item-card" style={{position:'relative'}}>
      {tag === 'Usage Interne' && (
        <span style={{position:'absolute',top:10,right:10,background:'#1976d2',color:'#fff',borderRadius:12,padding:'2px 12px',fontSize:'0.92rem',fontWeight:600,boxShadow:'0 2px 8px rgba(25,118,210,0.10)'}}>{t.usageInterne}</span>
      )}
      <img src={photo} alt={label} className="item-photo" />
      <div className="item-info">
        <h3>{used_label}</h3>
        <p><b>{t.pid} :</b> {pid_number ?? '-'}</p>
        <p><b>{t.gmcce} :</b> {used_gmcce ?? '-'}</p>
        <p><b>{t.pdvFinal ?? 'Prix final'} :</b> {pdv_final ?? '-'}€</p>
        <p><b>{t.pdvFiliale ?? 'Prix filiale'} :</b> {pdv_filiale ?? '-'}€</p>
        <p><b>{t.availableStock} :</b> {item.available_stock ?? '-'}</p>
        <p><b>{t.pending} :</b> {item.pending_stock ?? '-'}</p>
        <button className='button-details' onClick={onDescriptif}>{t.descriptif ?? 'Descriptif'}</button>
      </div>
    </div>
  );
};

export default ItemCard;
